export const msalConfig = {
  auth: {
    clientId: "d13a0b54-94bf-48b8-984b-a7eb4fcaa154",
    authority: "https://login.microsoftonline.com/93ffc029-7dbf-40be-a43e-1b289c45cb82",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginScopes = ["User.Read", "User.ReadBasic.All", "Files.ReadWrite.All", "Sites.ReadWrite.All", "Mail.Send"];

// Scope for our own backend API (exposed on this same app registration via
// "Expose an API"). The SQL/Claude clients acquire a token for this and send it
// as a bearer token so the function apps can validate the caller server-side.
export const apiScopes = ["api://d13a0b54-94bf-48b8-984b-a7eb4fcaa154/access_as_user"];

// Azure Storage, as the signed-in user (drawing storage — docs/implementation/DRAWING_STORAGE_PLAN.md). Needs the
// "Azure Storage ▸ user_impersonation" delegated permission on this app registration with admin consent, and the
// user's group holding a Storage Blob Data role on the drawings container. Until then the token request fails soft.
export const storageScopes = ["https://storage.azure.com/user_impersonation"];

// ── Admin authorization (2026-09-11) ───────────────────────────────────────────
// Admins are the members of the Entra security group SWA-ESTIMATING-ADMIN —
// managed in the Azure portal (Entra ID ▸ Groups), NOT in this codebase.
// Adding or removing an admin is a group-membership change, no deploy. See
// src/auth/AdminContext.jsx for how membership is resolved (ID-token `groups`
// claim first, Graph checkMemberGroups as the fallback) and
// cs-est-sql-api/shared/adminProcs.js for the server-side enforcement that
// reads the same group id from the API token. Group object id, not a secret
// (same as clientId/tenant above).
export const ADMIN_GROUP_ID = "d4cbbd6d-2578-41e4-80dd-029f8cd6faf4";

// Break-glass ONLY: used when group membership genuinely cannot be
// determined (no groups claim AND the Graph call failed — e.g. a Graph
// outage or a revoked consent), so a bad day can't lock every admin out of
// Setup. It is never consulted when membership resolves to a definite
// yes/no. Empty string disables it.
export const BREAK_GLASS_ADMIN_EMAIL = "nvermont@cleanspaceus.com";
